import { observer } from "mobx-react";
import React from "react";
import Icon from "../../components/Icons/Icon";
import { Badge } from "@mui/material";
import GlobelStore from "../../Store/GlobelStore";

const ClientWidget = observer(() => {
  return (
    <div className="notificationContainer clientWidgetContainer">
      <div className="clienWidgetTitle">Total Client</div>
      <div className="clientWidgetSubTitle">
        {GlobelStore?.dashboardAllData?.totalConnectedClients}
      </div>
    </div>
  );
});

export default React.memo(ClientWidget);
